export const getActionButtons = () => [];
export const getText = (notification) => notification.data.text;
